module.exports = __webpack_public_path__ + "img/iapetus.3a996a2f.png";